module.exports = __webpack_public_path__ + "img/electronic_electric_use.26791dd1.svg";